import getStaticData from '../helpers/getStaticData'

const msalData = getStaticData('msal')
const sitecoreData = getStaticData('sitecore')
let environment = ''

//Map AD B2C tenantId to environment subdomain
switch (msalData?.tenantId) {
  case 'ce2a2c99-5c0e-45f3-90c3-4e7ea77d2a85':
    environment = 'partnerlogin-acc'
    break
  case '6e067d63-7e36-481d-b24c-5963faf9dab1':
    environment = 'partnerlogin'
    break
  default:
    environment = 'partnerlogin'
    break
}

const adB2cBaseUrl = `${environment}.transavia.com`
const adB2cBaseAuthority = `https://${adB2cBaseUrl}/tfp/${msalData?.tenantId}`

// Config object to be passed to Msal on creation
export const msalConfig = {
  auth: {
    clientId: msalData?.clientId,
    authority: `${adB2cBaseAuthority}/B2C_1A_PARTNER_SIGNIN`,
    knownAuthorities: [adB2cBaseUrl],
    redirectUri: sitecoreData.basePath,
    postLogoutRedirectUri: sitecoreData.basePath,
  },
}

export function loginRequest() {
  const cultureCode = msalData?.cultureCode || 'en-NL'
  const adB2cLocale = determineAdB2cLocale(cultureCode)

  return {
    scopes: ['openid'],
    extraQueryParameters: {
      locale: cultureCode,
      ui_locales: adB2cLocale,
    },
  }
}

export function accessTokenRequest() {
  const request = { scopes: ['offline_access'] }

  if (sessionStorage.getItem('adb2c_access_token_policy')) {
    request.authority = `${adB2cBaseAuthority}/${sessionStorage.getItem(
      'adb2c_access_token_policy'
    )}`
  }

  return request
}

function determineAdB2cLocale(locale) {
  let adB2cLocale = locale

  if (locale === 'en-NL') {
    adB2cLocale = 'en-US'
  }

  return adB2cLocale
}
